// Full-screen toggle for phones. Browsers without the Fullscreen API (iPhone
// Safari) never see the button.
import { t } from "../core/i18n.js";
import { icon } from "./icons.js";

const supported = () =>
  typeof document !== "undefined" &&
  !!(document.fullscreenEnabled || document.webkitFullscreenEnabled);
const active = () =>
  !!(document.fullscreenElement || document.webkitFullscreenElement);
const label = (on) => t(on ? "Exit full screen" : "Full screen");

export function fullscreenButton() {
  if (!supported()) return "";
  const on = active();
  return `<button type="button" class="fullscreen-toggle" data-fullscreen aria-pressed="${on}" aria-label="${label(on)}" title="${label(on)}">${icon(on ? "minimize" : "maximize")}</button>`;
}

function sync() {
  const on = active();
  document.body.classList.toggle("is-fullscreen", on);
  document.querySelectorAll("[data-fullscreen]").forEach((button) => {
    button.setAttribute("aria-pressed", String(on));
    button.setAttribute("aria-label", label(on));
    button.title = label(on);
    button.innerHTML = icon(on ? "minimize" : "maximize");
  });
}

async function toggle() {
  try {
    if (active())
      await (document.exitFullscreen || document.webkitExitFullscreen).call(
        document,
      );
    else {
      const root = document.documentElement;
      await (root.requestFullscreen || root.webkitRequestFullscreen).call(
        root,
        { navigationUI: "hide" },
      );
    }
  } catch {
    // The browser refused (for example outside a user gesture); nothing changes.
  }
  sync();
}

export function bindFullscreen() {
  if (!supported()) return;
  // The workspace top bar is static markup, so its button is added once here.
  document
    .getElementById("accountMobile")
    ?.insertAdjacentHTML("beforebegin", fullscreenButton());
  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-fullscreen]")) void toggle();
  });
  document.addEventListener("fullscreenchange", sync);
  document.addEventListener("webkitfullscreenchange", sync);
  window.addEventListener("dayx:language", sync);
}
